export function LoginWithTokenController(
    $window,
    $stateParams,
    AuthenticationError,
    loginWithTokenResult,
    SessionStorageCacheService,
    BASE_PATH_PUBLIC
) {
    function initialize() {
        SessionStorageCacheService.clear();
        // Clear resource string data for the domain after being redirected from global signin
        window.localStorage.removeItem('rss-data');
        window.localStorage.removeItem('rss-last-requested');
        window.localStorage.removeItem('last-resource-string-request');

        if (loginWithTokenResult.success) {
            $window.location.href = loginWithTokenResult.data.RedirectUrl;
        } else if (loginWithTokenResult.errorCode === 227 || loginWithTokenResult.errorCode === 225) {
            // If the token is invalid we send the user back to the login page.
            const queryObj = {};

            const returnUrl = $stateParams.returnUrl || $stateParams.ReturnUrl;
            if (returnUrl) {
                queryObj.returnUrl = returnUrl;
            }

            switch (loginWithTokenResult.errorCode) {
                case 227:
                    queryObj.authError = AuthenticationError.InvalidTokenErrorMessage;
                    break;
                case 225:
                    queryObj.authError = AuthenticationError.BlockedUserError;
                    break;
                default:
                    queryObj.authError = AuthenticationError.InvalidTokenErrorMessage;
                    break;
            }
            $window.location.href = `${BASE_PATH_PUBLIC}/authentication/login?authError=${queryObj.authError}&returnUrl=${queryObj.returnUrl}`;
        }
    }

    initialize();
}

LoginWithTokenController.$inject = [
    '$window',
    '$stateParams',
    'AuthenticationError',
    'loginWithTokenResult',
    'SessionStorageCacheService',
    'BASE_PATH_PUBLIC'
];
